// extracted by mini-css-extract-plugin
export var editButton = "_qz-0";